module.exports = __webpack_public_path__ + "img/822004534.6b123b72.png";